var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPublish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81.183,
    height: 81.175,
    viewBox: "0 0 81.183 81.175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5594",
    "data-name": "Rectangle 5594",
    width: 81.183,
    height: 81.175,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_189887",
    "data-name": "Group 189887",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_189886",
    "data-name": "Group 189886",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42953",
    "data-name": "Path 42953",
    d: "M54.231,81.175a3.019,3.019,0,0,1-1.381-1.639Q45.3,62.011,37.741,44.491a1.646,1.646,0,0,0-1.037-.96Q21.27,37.623,5.846,31.693c-1.376-.528-2.744-1.075-4.128-1.58A3.561,3.561,0,0,1,0,28.846V27.578c.87-1.273,2.341-1.427,3.624-1.867q17.419-5.975,34.86-11.886Q58.457,7.019,78.427.2A1.979,1.979,0,0,1,80.7.53a2.016,2.016,0,0,1,.293,2.215Q74.113,24.3,67.253,45.871,61.931,62.592,56.625,79.318a2.707,2.707,0,0,1-1.443,1.857Zm.249-6.83L75.467,8.386c-1.151.944-2.158,1.98-3.179,3Q56.819,26.853,41.337,42.306a.866.866,0,0,0-.233,1.154c.685,1.482,1.311,2.991,1.958,4.491q4.507,10.448,9.014,20.9c.769,1.78,1.552,3.553,2.4,5.5M6.966,28.31c1.407.546,2.62,1.021,3.836,1.488Q24.124,34.916,37.44,40.05A1.233,1.233,0,0,0,39,39.7q14.314-14.358,28.664-28.68Q70.124,8.566,72.6,6.128l-.1-.157L6.966,28.31",
    transform: "translate(0 0)",
    fill: "#6a3089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42954",
    "data-name": "Path 42954",
    d: "M0,217.818c5.4-5.651,11.017-11.081,16.519-16.628q4.212-4.247,8.458-8.459c1.061-1.058,2.333-1,3.007.124a1.533,1.533,0,0,1-.039,1.781,5.743,5.743,0,0,1-.67.779Q15.428,207.276,3.58,219.134A6.061,6.061,0,0,1,2.22,220.2H1.269A3.4,3.4,0,0,1,0,218.928Z",
    transform: "translate(0 -139.021)",
    fill: "#f26e14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42955",
    "data-name": "Path 42955",
    d: "M0,179.8q6.247-6.271,12.493-12.543a2.044,2.044,0,0,1,2.084-.784,1.7,1.7,0,0,1,1.062,2.5,5.045,5.045,0,0,1-.76.9Q9.261,175.5,3.634,181.127C2.1,182.666,1.371,182.655,0,181.064V179.8",
    transform: "translate(0 -120.503)",
    fill: "#f26e14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42956",
    "data-name": "Path 42956",
    d: "M71.576,252.638c-1.549-1.186-1.6-2.12-.176-3.539q5.768-5.765,11.538-11.529c1.052-1.049,2.26-1.062,2.976-.048a1.6,1.6,0,0,1,.052,1.907,4.384,4.384,0,0,1-.6.727q-5.788,5.8-11.588,11.6a13.384,13.384,0,0,1-1.089.886Z",
    transform: "translate(-50.962 -171.463)",
    fill: "#f26e14"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPublish);
export default __webpack_public_path__ + "static/media/icon-publish.4c0f8f9b7efd0b97aca61b35215def30.svg";
export { ForwardRef as ReactComponent };